import React from "react";
import Style from "../Style/PlateForm.module.scss";
import { FaGraduationCap } from "react-icons/fa";
import { Link } from "react-router-dom";

const PlateForm = ({ darkMode }) => {
  const data = [
    {
      title: "Programs",
      icon: <FaGraduationCap />,
      bg: "#A3D366",
    },
  ];

  return (
    <div className={`${Style.PlateForm} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.PlateFormFlex}>
          <div className={Style.Plateleft}>
            <h2>Best Platform to Upgrade</h2>
          </div>

          <div className={Style.Plateright}>
            {data.map((item, index) => (
              <Link
                to="/courses"
                key={index}
                className={Style.card}
                style={{ backgroundColor: item.bg }}
              >
                <div className={Style.icon}>{item.icon}</div>
                <h4>{item.title}</h4>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlateForm;
